import PropTypes from 'prop-types';

import {
    Avatar,
    Image
} from '@mantine/core';

import {AiOutlineAppstore} from 'react-icons/ai';
import {Application} from '../types';
import {getApplicationLogo} from '../../../../utils/getApplicationLogo.ts';

export const AccountApplicationLogo = ({
                                           record,
                                           size = '70',
                                       }: {
    record: Application,
    size?: string
}) => {
    const alt = record.name;

    if (record.logoUrl) {
        return <Image src={record.logoUrl}/>
    }

    const localLogo = getApplicationLogo(record.name);
    if (localLogo) {
        return <Image src={localLogo} alt={alt} h={size} w="auto" fit="contain"/>;
    }

    return (
        <Avatar alt={alt} size={size}>
            <AiOutlineAppstore/>
        </Avatar>
    );
};

AccountApplicationLogo.propTypes = {
    record: PropTypes.shape({
                                name: PropTypes.string,
                            }),
    size: PropTypes.number,
};

